// extracted by mini-css-extract-plugin
export default {"image_desktop":"tlgQ","image_mobile":"_1bza"};